export default "__VITE_ASSET__3448a40d__"